import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";

const HeroSection = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [videoEnded, setVideoEnded] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    const checkScreen = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  // ✅ Force video play (prevents random pause)
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play().catch(() => {});
    }
  }, []);

  return (
    <section
      style={{ backgroundColor: "#032d28" }}
      className="relative w-full h-screen md:h-[85vh] flex items-center justify-center overflow-hidden font-sans transition-colors duration-1000"
    >
      {/* Background Media */}
      {!isMobile && (
        <video
          ref={videoRef}
          className={`absolute inset-0 w-full h-full object-cover pointer-events-none transition-opacity duration-1000 ${
            videoEnded ? "opacity-0" : "opacity-100"
          }`}
          autoPlay
          muted
          playsInline
          preload="auto"
          onEnded={() => setVideoEnded(true)}
        >
          <source
            src="https://res.cloudinary.com/dpn3bkjba/video/upload/v1774457054/65080baa3f9a607985451de3_68909ddb23cb642ec71075bd_Lakera_Hero_Desktop-transcode_qerfcw.mp4"
            type="video/mp4"
          />
        </video>
      )}

      {isMobile && (
        <img
          src="https://res.cloudinary.com/dpn3bkjba/image/upload/v1774510896/home_img_fyunlv.png"
          className="absolute inset-0 w-full h-full object-cover"
          alt="hero-bg"
        />
      )}

      {/* Overlay */}
      <div className="absolute inset-0" />

      {/* Content */}
      <div className="relative z-10 w-full max-w-[1100px] mx-auto px-6 text-white text-center flex flex-col items-center justify-center translate-y-[6vh] md:translate-y-[8vh]">
        <h1 className="text-[clamp(1.8rem,4vw,3.2rem)] font-semibold tracking-[-0.02em] leading-[1.2] max-w-[900px] mx-auto">
          Secure Your Enterprise for the{" "}
          <span className="bg-gradient-to-r from-green-300 via-emerald-400 to-teal-400 bg-clip-text text-transparent">
            Cloud and AI Era
          </span>
        </h1>

        <p className="text-base md:text-xl text-white max-w-3xl mx-auto font-light leading-relaxed mt-6 mb-10 opacity-80">
          We design, deploy, and operate modern security architectures for the
          cloud and AI era.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-5">
          <Link
            to="/Contact"
            className="w-[200px] py-3.5 bg-[#1a1d1f] border border-white/20 text-white rounded-xl font-semibold text-base 
    hover:bg-[#2a2f32] hover:border-white/40 hover:shadow-lg 
    transition-all duration-300 no-underline"
          >
            Talk to a Security Expert
          </Link>

          <Link
            to="/Services"
            className="w-[180px] py-3.5 bg-white text-black rounded-xl font-semibold text-base 
    hover:bg-gray-200 hover:shadow-lg 
    transition-all duration-300 no-underline"
          >
            Explore Our Services
          </Link>
        </div>
      </div>

      {/* Bottom Fade */}
      <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-[#010c0b] to-transparent" />
    </section>
  );
};

export default HeroSection;
